import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';

const SettingsLayout: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (location.pathname === '/settings') {
      navigate('/settings/general', { replace: true });
    }
  }, [location.pathname, navigate]);

  return <Outlet />;
};

export default SettingsLayout;
